import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { parse } from 'qs';
import * as Institution from '../constants/Institution';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

export default class InstitutionDetail extends Component {

  componentDidMount = () => {
    const query = parse(this.props.location.search.substr(1));
    this.props.institutionActions.get(query.id);
  }

  render() {
    const institutionInfo = this.props.institution.institution;
    let institution = null;
    if (institutionInfo === null) {
      return (
        <div style={{position: 'relative', margin: 'auto', textAlign: 'center'}}>
          <CircularProgress size={200} thickness={15} />
        </div>
      );
    }

    const infoKey = Object.assign(Institution.Model, {
      "created_at": "データ追加時間",
      "updated_at": "データ更新時間",
    });

    institution = Object.keys(infoKey).map((key) => {
      // institutionプロパティの中に入っていることに注意.
      const info = institutionInfo.institution;

      if (info.hasOwnProperty(key)) {
        return (
          <TableRow key={key}>
            <TableRowColumn>{infoKey[key]}</TableRowColumn>
            <TableRowColumn>{info[key]}</TableRowColumn>
          </TableRow>
        );
      } else {
        return null;
      }
    });

    let updateUrl = "/institutions/update?id=" + institutionInfo["id"];

    return (
      <div>
        <Table selectable={false} style={{position: 'relative', margin: 'auto', textAlign: 'center'}}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false} style={{
              margin: 'auto', textAlign: 'center'
            }}>
            <TableRow>
              <TableHeaderColumn>Key</TableHeaderColumn>
              <TableHeaderColumn>Value</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} style={{
              margin: 'auto', textAlign: 'center'
            }}>
            {institution}
          </TableBody>
        </Table>
        <RaisedButton label="Update" href={updateUrl} primary={true} style={{margin: 12}} />
      </div>
    );
  }
}

InstitutionDetail.propTypes = {
  institution: PropTypes.object.isRequired,
  institutionActions: PropTypes.object.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/InstitutionDetail.js